// extracted by mini-css-extract-plugin
export default {"red-theme":"colors_red-theme__Yd2QL","pink-theme":"colors_pink-theme__Pfuv7","blue-theme":"colors_blue-theme__4xdTG"};